import { useGetBreakpointMediaQuery } from './useGetBreakpointMediaQuery';
export const useBreakpointMediaQueryMap = (type) => {
    const { getBreakpointMediaQuery } = useGetBreakpointMediaQuery(type);
    return {
        xs: getBreakpointMediaQuery('xs'),
        sm: getBreakpointMediaQuery('sm'),
        md: getBreakpointMediaQuery('md'),
        lg: getBreakpointMediaQuery('lg'),
        xl: getBreakpointMediaQuery('xl'),
    };
};
